import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { TUnitType, UnitCodeFromUnitType } from "@cmodules/checklist/assets/data/types/vm/template-builder/unit-code"

export class ConstantOptionsVM extends CommonOptionVM {
  read_only?: boolean
  grouping_separator?: boolean
  default_value?: number
  units?: UnitCodeFromUnitType[]
  unit_type?: TUnitType

  constructor(data: Partial<ConstantOptionsVM> = {}) {
    super(data)
    this.read_only = data.read_only || undefined
    this.grouping_separator = data.grouping_separator || undefined
    this.default_value = data.default_value || undefined
    this.units = data.units || []
    this.unit_type = data.unit_type || undefined
  }

  validateData() {
    const errors: any[] = []
    if (!this.default_value) {
      errors.push({ key: 'default_value', error_message: 'Default value is required' })
    }
    /**
     * *** ### Add check for units types
     *  */
    // if (this.units && this.units.length > 0 && this.units.filter(x => UnitTypesMap.includes(x))) {
    //   errors.push({key: 'units', error_message: 'Calculations items must not be empty'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default ConstantOptionsVM
